<!-- 查询搜索结果 -->
<template>
    <div :class="resultExpand? 'search-results expand': 'search-results'">
        <!--查询结果列表-->
        <div v-show="componentShow === 'mapSearchResultsList'" style="height: 100%;width: 100%;">
            <map-search-results-list ref="mapSearchResultsList"></map-search-results-list>
        </div>
        <!--详情-->
        <div v-if="componentShow === 'mapDetails'" style="height: 100%;width: 100%;">
            <mobileMoreDetails ref="refdetailsShow"></mobileMoreDetails>
        </div>
        <!--搜索周边-->
        <div v-show="componentShow === 'mapSearchAround'" style="height: 100%;width: 100%;">
            <map-search-around ref="refsearchAround" @goback="goback"></map-search-around>
        </div>
        <!--常见问题-->
        <div v-show="commonProblemShow">
            <common-problem></common-problem>
        </div>
        <!--地块对比-->
        <div v-show="plotContrastListShow">
            <plot-contrast-list ref="refplotContrastList"></plot-contrast-list>
        </div>
        <!--地块对比表格-->
        <div v-show="plotContrastTableShow">
            <plot-contrast-table ref="refplotContrastTable"></plot-contrast-table>
        </div>
    </div>
</template>

<script>
import mapDetails from '@/views/map-view/mapDetails'
import mapSearchResultsList from '@/views/mobile-view/mapSearchResultsList'
import mapSearchAround from '@/views/map-view/mapSearchAround'
import commonProblem from '@/views/map-view/commonProblem'
import plotContrastList from '@/views/map-view/plotContrastList'
import plotContrastTable from '@/views/map-view/plotContrastTable'
import mobileMoreDetails from '@/views/mobile-view/mobileMoreDetails'

export default {
  components: {
    mapDetails, mapSearchResultsList, mapSearchAround, commonProblem, plotContrastList, plotContrastTable, mobileMoreDetails
  },
  data() {
    return {
      componentShow: 'mapSearchResultsList',
      resultExpand: false,
      resultlistShow: false,
      commonProblemShow: false,
      plotContrastListShow: false,
      plotContrastTableShow: false,
      feature: null,
      isFromMap: false
    }
  },
  watch: {
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    //
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // todo
  },
  methods: {
    resultsDetails(feature, isFromMap) {
      const _this = this
      // this.resultActive = index
      this.feature = feature
      this.isFromMap = isFromMap
      // 数据来源于地图点击
      if (isFromMap) {
        this.$parent.$refs.search.keyWord = feature.properties.dkmc
        const resultListViewShow = this.$parent.$refs.search.resultListViewShow
        if (resultListViewShow) {
          this.resultlistShow = true
        } else {
          this.resultlistShow = false
        }
      }
      this.componentShow = 'mapDetails'
      this.resultExpand = true
      setTimeout(() => {
        _this.$refs.refdetailsShow.settingData(feature, true)
      }, 300)
      //  查询结果不显示tooltip
    },
    initResultList(keyWord, ydxz) {
      this.resultlistShow = true
      this.componentShow = 'mapSearchResultsList'
      this.$refs.mapSearchResultsList.initResultList(keyWord, ydxz)
    },
    goback() {
      this.resultsDetails(this.feature, this.isFromMap)
    },
    handleSizeChange() {
      //
    },
    handleCurrentChange() {
      //
    }

  }
}
</script>
<style lang="scss" scoped>
    .search-results {
        position: absolute;
        bottom: 0px;
        z-index: 1200;
        width: 100%;
        background: #fff;
        border-radius: 4px;
        padding-bottom: 10px;
        height: 50%;
        box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
        &.expand{
            height: 100%;
        }
    }
</style>
